import { inject, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DatetimeAdapter } from '@ng-matero/extensions/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { updateDateLocale } from '@src/suite/common/utils/util';
import { DateTime } from 'luxon';
import { map, of } from 'rxjs';

import { HelloResultsActions } from './hello-results.actions';
import { selectDateLocale, selectDayOfWeek } from './hello-results.selectors';

@Injectable()
export class HelloResultsEffects {
    actions$ = inject(Actions);
    store = inject(Store);
    dateTimeAdapter = inject(DatetimeAdapter<DateTime>);
    dateAdapter = inject(DateAdapter<DateTime>);

    updateDateLocale$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(HelloResultsActions.processHelloResults, HelloResultsActions.setLanguageSettings),
                concatLatestFrom(() => [this.store.select(selectDateLocale), this.store.select(selectDayOfWeek)]),
                map(([_, dateLocale, dayOfWeek]) => {
                    this.dateTimeAdapter.setLocale(dateLocale);
                    this.dateAdapter.setLocale(dateLocale);

                    updateDateLocale(dateLocale, dayOfWeek);
                    return of(dateLocale);
                })
            );
        },
        { dispatch: false }
    );
}
